import { useCalculatedSize } from '@slot-nx/core'
import { Size } from '@slot-nx/core'
import { css } from '../../../styled-system/css'

export const GameSize = ({ children, element, resolution }: { children: React.ReactNode, element: HTMLElement, resolution: Size }) => {
  const actualSize = useCalculatedSize(element, resolution)
  const scale = actualSize.width / resolution.width
  return (
    <div
      id="game-size-container"
      style={{
        transform: `translate(-50%, -50%) scale(${scale})`,
        width: `${resolution.width}px`,
        height: `${resolution.height}px`,
        pointerEvents: 'none',
        zIndex: 1,
      }}
      className={css({
        overflow: 'hidden',
        position: 'absolute',
        top: '50%',
        left: '50%',
      })}
    >
      <div
        id="game-relative-container"
        className={css({
          'position': 'relative',
          'width': '100%',
          'height': '100%',
          '& *': {
            pointerEvents: 'auto',
          },
        })}
      >
        {children}
      </div>
    </div>
  )
}
